import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPivotaltrackerComponent } from './simple-icons-pivotaltracker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPivotaltrackerComponent ],
    exports:      [ SimpleIconsPivotaltrackerComponent ],
    bootstrap:    []
})
export class SimpleIconsPivotaltrackerModule {}
